
import Signature from "@/domain/model/user/Signature.js";
import RcDomainObject from "../../common/RcDomainObject.js";
import ChecklistResultMap from "../checklist/result/ChecklistResultMap.js";
import CommentMap from "../comment/CommentMap.js";
import Company from "../company/Company.js";
import Employee from "../employee/Employee.js";
import Schedule from "../schedule/Schedule.js";
import Vehicle from "../vehicle/Vehicle.js";
import VehicleMap from "../vehicle/VehicleMap.js";
import RepairResultMap from "./repair/result/RepairResultMap.js";
import Result from "./result/Result.js";
import ResultMap from "./result/ResultMap.js";

import DateUtils from '@/utils/DateUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import Catalog from '@/domain/session/Catalog.js';
import RcDate from '@/domain/session/time/RcDate.js';
import RcTime from "../../session/time/RcTime.js";
import User from "../user/User.js";
import VehicleUtils from "../vehicle/VehicleUtils.js";
export default class Inspection extends RcDomainObject {

  static MODEL_NAME = Vehicle.MODEL_NAME + "Inspection";

  static Fields = {
    COMMENTS: CommentMap.MODEL_NAME,
    PDF_URL: "pdfUrl",
    CREATED_DATE: 'createdDate',
    DEFECT_TYPE: 'defectType',
    VEHICLE: Vehicle.MODEL_NAME,
    ODOMETER: 'odometer',
    TRAILERS: 'trailerMap',
    RESULTS: 'VehicleInspectionResultMap',
    REPAIR_RESULTS: 'VehicleInspectionRepairResultMap',
    PRE_TRIP_IOS: "pretrip",
    PRE_TRIP_ANDROID: "preTrip",
    TRIP: "trip",
    LOCATION: "location",
    SCHEDULE: "VehicleSchedule",
    COMPANY: "Company",

    DRIVER: "driver",
    DRIVER_DATE: "driverDate",
    DRIVER_SIGNATURE: "driverSignature",
    DRIVER_INSPECTION_DATE: "driverDate",

    INSPECTOR: "inspector",
    INITIAL_INSPECTOR_SIGNATURE: "inspectorSignature",
    INSPECTOR_INSPECTION_DATE: "initialDate",

    ENROUTE_INSPECTOR: 'enrouteInspector',
    ENROUTE_INSPECTION_DATE: 'enrouteInspectionDate',
    ENROUTE_INSPECTOR_SIGNATURE: "enrouteSignature",

    REPAIRED: "repaired",
    Action: "action",
    CHECKLIST_RESULTS: ChecklistResultMap.MODEL_NAME,
    GPS_LOCATION: "gpsLocation",
  }

  static Values = {
    Trip: {
      PRE: "pre",
      POST: "post",
      isPre: function (value) {
        return value.toLowerCase() === Inspection.Values.Trip.PRE;
      },
    },
    Action: {
      Repair: "actionRepair",
    },
  }

  constructor(domain, data) {
    super(domain, data, Inspection.MODEL_NAME);
    this.C = new Catalog();
  }

  find() {
    return this.domain.inspections().findById(this.id());
  }

  pdfUrl() {
    let urls = this.pdfUrls();
    if (urls.length > 0) {
      var host = this.domain.client().cdnHost;
      var url = host + urls[0];
      return url;
    }
    return "";
  }

  pdfUrls() {
    var host = this.domain.client().cdnHost;
    let paths = StringUtils.split(this.getString(Inspection.Fields.PDF_URL), ";");
    let urls = [];
    for (let i = 0; i < paths.length; i++) {
      var url = host + paths[i];
      urls.push(url);
    }
    return urls;
  }

  uniquePdfUrls() {
    return [...new Set(this.pdfUrls())];
  }

  hasPdfUrl() {
    return !StringUtils.isEmpty(this.getString(Inspection.Fields.PDF_URL));
  }

  comments() {
    var obj = this.get(Inspection.Fields.COMMENTS);
    var comments = new CommentMap(this.domain, obj);
    return comments;
  }

  vehicle() {
    var obj = this.get(Inspection.Fields.VEHICLE);
    var item = new Vehicle(this.domain, obj);
    return item;
  }

  company() {
    var obj = this.get(Inspection.Fields.COMPANY);
    var item = new Company(this.domain, obj);
    return item;
  }

  withCompany(company) {
    this.put(Inspection.Fields.COMPANY, company);
    return this;
  }
  
  trailers() {
    var obj = this.get(Inspection.Fields.TRAILERS);
    var item = new VehicleMap(this.domain, obj);
    return item;
  }

  withTrailers(trailers) {
    this.put(Inspection.Fields.TRAILERS, trailers.data);
    return this;
  }

  vehicles() {
    var item = new VehicleMap(this.domain);
    var trailers = this.trailers();
    for (var id of trailers.keys()) {
      var trailer = trailers.getVehicle(id);
      item.add(trailer);
    }
    item.add(this.vehicle());
    return item;
  }

  withVehicle(vehicle) {
    this.put(Inspection.Fields.VEHICLE, vehicle.data);
    return this;
  }

  results() {
    var obj = this.get(Inspection.Fields.RESULTS);
    var item = new ResultMap(this.domain, obj);
    return item;
  }

  withResults(results) {
    this.put(Inspection.Fields.RESULTS, results.data);
    return this;
  }

  withResultsDirect(results) {
    this.put(Inspection.Fields.RESULTS, results.data);
    return this;
  }

  resultsForVehicle() {
    var results = this.results();
    return results.vehicle();
  }

  resultsForTrailers() {
    var results = this.results();
    return results.trailers();
  }

  hasComments() {
    return this.comments().length() > 0;
  }

  hasBeenRepaired() {
    var beenRepaired = this.getBoolean(Inspection.Fields.REPAIRED);
    if (!beenRepaired) {
      beenRepaired = this.hasRepairs();
    }
    return beenRepaired;
  }

  withBeenRepaired() {
    this.put(Inspection.Fields.REPAIRED, true);
    return this;
  }

  copy() {
    var data = this._copy();
    return new Inspection(this.domain, data);
  }

  odometer() {
    let value = this.getString(Inspection.Fields.ODOMETER);
    if (StringUtils.isEmpty(value)) {
      value = "0";
    }
    return value;
  }

  defectType() {
    return this.getString(Inspection.Fields.DEFECT_TYPE);
  }

  defectTypeDisplay() {
    var defectType = this.defectType();
    return VehicleUtils.defectDisplayValue(defectType);
  }

  hasDefect() {
    return !this.isDefectTypeGood();
  }

  isDefectTypeGood() {
    var defectType = this.defectType();
    if (StringUtils.eic(defectType, "major")) {
      return false;
    }
    if (StringUtils.eic(defectType, "minor")) {
      return false;
    }
    return true;
  }

  isDefectTypeMinor() {
    var defectType = this.defectType();
    if (StringUtils.eic(defectType, "minor")) {
      return true;
    }
    return false;
  }

  isDefectTypeMajor() {
    var defectType = this.defectType();
    if (StringUtils.eic(defectType, "major")) {
      return true;
    }
    return false;
  }

  withDefectType(defectType) {
    this.put(Inspection.Fields.DEFECT_TYPE, defectType);
    return this;
  }

  hasUnfixedDefect() {
    var defect = this.defectType();
    if (StringUtils.eic(defect, "None") || StringUtils.isEmpty(defect)) {
      if (this.hasTrailers()) {
        return this.hasUnfixedDefects(true);
      }
      return false;
    }
    return true;
  }

  hasUnfixedDefectsResultsOrChecklist() {
    return this.hasUnfixedDefects(true) || this.hasUnfixedDefectsInChecklists();
  }

  hasUnfixedDefects(includeDetachedTrailers) {
    var result = this.results().find().mostSevereUnfixedDefectType(includeDetachedTrailers);
    if (StringUtils.eic("None", result) || StringUtils.isEmpty(result)) {
      return false;
    }
    return true;
  }

  hasUnfixedDefectsInChecklists() {
    var result = this.checklistResults().find().mostSevereUnfixedDefectType();
    if (StringUtils.eic("None", result) || StringUtils.isEmpty(result)) {
      return false;
    }
    return true;
  }

  mostSevereUnfixedDefectType() {
    var result = this.results().find().mostSevereUnfixedDefectType(true);
    return result;
  }

  mostSevereUnfixedDefectTypeDisplay() {
    var defectType = this.mostSevereUnfixedDefectType();
    var display = "Good";
    if (StringUtils.eic(defectType, "major")) {
      display = "Major";
    }
    if (StringUtils.eic(defectType, "minor")) {
      display = "Minor";
    }
    return display
  }

  mostSevereUnfixedDefectTypeCalculation() {
    let defectType = Result.Values.DefectType.DEFECT_TYPE_NONE;
    let checklistDefectType = Result.Values.DefectType.DEFECT_TYPE_NONE;
    if (this.vehicle().find().hasSchedule()) {
      defectType = this.results().mostSevereUnfixedDefectType(false);
    }
    if (this.vehicles().hasAtLeastOneChecklist()) {
      checklistDefectType = this.checklistResults().mostSevereUnfixedDefectTypeCalculation();
      //Checklist only impacts the overall status when the schedule is set.
      if (this.vehicle().hasSchedule()) {
        checklistDefectType = Result.Values.DefectType.DEFECT_TYPE_NONE;
      }
    }
    defectType = Result.mostSevereDefectType(defectType, checklistDefectType);
    this
      .withDefectType(defectType)
      .done();
    return this;
  }

  isPreTrip() {
    if (this.has(Inspection.Fields.TRIP)) {
      var value = this.getString(Inspection.Fields.TRIP);
      return Inspection.Values.Trip.isPre(value);
    }

    if (this.has(Inspection.Fields.PRE_TRIP_ANDROID)) {
      var android = this.getString(Inspection.Fields.PRE_TRIP_ANDROID);
      return android.toLowerCase() === "true";
    }

    if (this.has(Inspection.Fields.PRE_TRIP_IOS)) {
      var ios = this.getString(Inspection.Fields.PRE_TRIP_IOS);
      return ios.toLowerCase() === "true";
    }

    return true;
  }

  tripDisplay() {
    if (this.vehicle().find().isEquipment()) {
      return "General";
    }
    if (this.isPreTrip()) {
      return this.C.get(Catalog.Inspection.PRE_TRIP);
    }
    return this.C.get(Catalog.Inspection.POST_TRIP);
  }

  location() {
    return this.getString(Inspection.Fields.LOCATION);
  }

  createDate() {
    return this.get(Inspection.Fields.CREATED_DATE);
  }

  createDateDisplay() {
    var createdDate = this.createdDate();
    return DateUtils.toDateTime(createdDate);
  }

  createdDate() {
    var createdDate = this.getInt(Inspection.Fields.CREATED_DATE);
    var timeZone = this.timeZone();
    var rcDate = new RcDate(new Date(createdDate), timeZone);
    return rcDate;
  }

  createdDateV2() {
    return this.createdDate();
  }

  createdDateDisplay() {
    var rcDate = this.createdDate();
    return rcDate.displayAs_YYYY_MM_DD_HH_MM_SS_A();
  }

  enrouteInspectionDate() {
    return this.getInt(Inspection.Fields.ENROUTE_INSPECTION_DATE);
  }

  enrouteInspectionDateDisplay() {
    var createdDate = this.enrouteInspectionDate();
    var timeZone = this.timeZone();
    var rcDate = new RcDate(new Date(createdDate), timeZone);
    return rcDate.displayAs_YYYY_MM_DD_HH_MM_SS_A();
  }

  enrouteSignature() {
    var data = this.get(Inspection.Fields.ENROUTE_INSPECTOR_SIGNATURE);
    return new Signature(this.domain, data);
  }

  enrouteInspector() {
    var data = this.get(Inspection.Fields.ENROUTE_INSPECTOR);
    var employee = new Employee(this.domain, data);
    return employee;
  }

  hasEnrouteInspector() {
    var inspector = this.enrouteInspector();
    return !inspector.isNew();
  }

  driver() {
    return this.driverInspector();
  }

  withDriver(driver) {
    this.put(Inspection.Fields.DRIVER, driver.data);
    return this;
  }

  withDriverSignature(signature) {
    this.put(Inspection.Fields.DRIVER_SIGNATURE, signature.data);
    return this;
  }

  hasDriver() {
    var driver = this.driver();
    return !driver.isNew();
  }

  driverInspectionDate() {
    return this.getInt(Inspection.Fields.DRIVER_INSPECTION_DATE);
  }

  driverInspectionDateDisplay() {
    var createdDate = this.driverInspectionDate();
    var timeZone = this.timeZone();
    var rcDate = new RcDate(new Date(createdDate), timeZone);
    return rcDate.displayAs_YYYY_MM_DD_HH_MM_SS_A();
  }

  driverInspector() {
    var data = this.get(Inspection.Fields.DRIVER);
    var employee = new Employee(this.domain, data);
    return employee;
  }

  driverSignature() {
    var data = this.get(Inspection.Fields.DRIVER_SIGNATURE);
    return new Signature(this.domain, data);
  }

  hasVerifier() {
    return false;
  }

  repairResults() {
    var data = this.get(Inspection.Fields.REPAIR_RESULTS);
    var repairResults = new RepairResultMap(this.domain, data);
    return repairResults;
  }

  withRepairResults(repairResults) {
    this.put(Inspection.Fields.REPAIR_RESULTS, repairResults.data);
    return this;
  }

  hasRepairs() {
    return this.repairResults().size() > 0;
  }

  inspector() {
    var data = this.get(Inspection.Fields.INSPECTOR);
    var employee = new Employee(this.domain, data);
    return employee;
  }

  inspectorInspectionDate() {
    return this.get(Inspection.Fields.INSPECTOR_INSPECTION_DATE);
  }

  inspectorSignature() {
    var data = this.get(Inspection.Fields.INITIAL_INSPECTOR_SIGNATURE);
    return new Signature(this.domain, data);
  }

  withInspector(inspector) {
    this.put(Inspection.Fields.INSPECTOR, inspector.data);
    return this;
  }

  withInspectorSignature(signature) {
    this.put(Inspection.Fields.INITIAL_INSPECTOR_SIGNATURE, signature.data);
    return this;
  }

  inspectorInspectionDateDisplay() {
    var createdDate = this.inspectorInspectionDate();
    var timeZone = this.timeZone();
    var rcDate = new RcDate(new Date(createdDate), timeZone);
    return rcDate.displayAs_YYYY_MM_DD_HH_MM_SS_A();
  }

  schedule() {
    var scheduleData = this.get(Inspection.Fields.SCHEDULE);
    return new Schedule(this.domain, scheduleData);
  }

  withSchedule(schedule) {
    this.put(Inspection.Fields.SCHEDULE, schedule.data);
    return this;
  }

  hasTrailers() {
    var isEmpty = this.trailers().isEmpty();
    return !isEmpty;
  }

  addResults(results) {
    var keys = results.keys();
    var existing = this.results();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var result = results.get(key);
      existing.add(result);
    }
    this.withResults(existing);
    return this;
  }

  withAction(action) {
    this.put(Inspection.Fields.Action, action);
    return this;
  }

  withActionRepair() {
    this.withAction(Inspection.Values.Action.Repair);
    return this;
  }

  workOrderDisplay() {
    var results = this.repairResults().find();
    if (!results) {
      return "";
    }
    let list = results.list();
    let workOrders = "";
    for (let i = 0; i < list.length; i++) {
      let repairResult = list[i];
      let workOrder = repairResult.workOrders();
      workOrders += " " + workOrder;
    }

    return StringUtils.trim(workOrders);
  }

  modifiedBy() {
    return new User(this.domain, this.get(Employee.DefaultFields.MODIFIED_BY));
  }

  createdBy() {
    return new User(this.domain, this.get(Employee.DefaultFields.CREATED_BY));
  }

  checklistResults() {
    var object = this.get(Inspection.Fields.CHECKLIST_RESULTS);
    return new ChecklistResultMap(this.domain, object);
  }

  withChecklistResult(checklistResults) {
    this.put(Inspection.Fields.CHECKLIST_RESULTS, checklistResults.data);
    return this;
  }

  addChecklistResult(checklistResult) {
    let checklistResults = this.checklistResults();
    checklistResults.addChecklistResult(checklistResult);
    return this.withChecklistResults(checklistResults);
  }

  withChecklistResults(checklistResults) {
    this.put(Inspection.Fields.CHECKLIST_RESULTS, checklistResults.data);
    return this;
  }

  isValid() {
    let now = RcTime.time().now();
    let cd = this.createdDateV2();
    let diff = now.time() - cd.time();
    if (diff > DateUtils.hours24()) {
      return false;
    }
    return true;
  }

  load() {
    let vehicles = this.vehicles().find();
    let inspectionVehicle = vehicles.getVehicle(this.vehicle().id());
    let inspectionTrailers = vehicles.trailers();
    this
      .withVehicle(inspectionVehicle)
      .withTrailers(inspectionTrailers)
      .done();
    this
      .withCreatedBy(this.createdBy().find())
      .done();
    this
      .withModifiedBy(this.modifiedBy().find())
      .done();

    this.withSchedule(this.schedule().find());

    let results = this.results().load();
    let keys = results.keys();
    for (let id in keys) {
      let result = results.getResult(keys[id]);
      let vehicle = vehicles.getVehicle(result.vehicle().id());
      result.withVehicle(vehicle);
      result.withSchedule(vehicle.schedule().find());
    }
    this.withResultsDirect(results);

    let repairResults = this.repairResults().load();
    this.withRepairResults(repairResults);

    let driver = this.driver().find();
    this.withDriver(driver);
    this.withDriverSignature(this.driverSignature().find());

    this.withInspector(this.inspector().find());
    this.withInspectorSignature(this.inspectorSignature().find());

    let checklistResults = this.checklistResults().find();
    checklistResults.load();
    this.withChecklistResult(checklistResults);
  }

  debug(title = "Inspection Debug") {
    let logger = this.domain.logger();

    let checklistResultMap = this.checklistResults();
    let checklistResultList = checklistResultMap.sortByCreatedDate();
    for (let checklistResult of checklistResultList) {
      let checklistItemResultMap = checklistResult.itemResults();
      let sortedList = checklistItemResultMap.list();
      logger.info(title);
      logger.info("Start Checklist Result Id: {0}", checklistResult.id());
      logger.info("       Checklist Id: {0}({1})", [checklistResult.checklist().name(), checklistResult.checklist().id()]);
      logger.info("       Company   Id: {0}({1})", [checklistResult.company().name(), checklistResult.company().id()]);
      logger.info("       Vehicle   Id: {0}({1})", [checklistResult.vehicle().name(), checklistResult.vehicle().id()]);
      logger.info("       Employee  Id: {0}({1})", [checklistResult.employee().user().find().fullName(), checklistResult.employee().id()]);
      logger.info("       Defect Type : {0}", checklistResult.defectType());
      logger.info("       Result Type : {0}", checklistResult.resultType());
      logger.info("       Start Checklist Item Results {0}--------------------------", sortedList.length);

      for (let itemResult of sortedList) {
        let item = itemResult.item().find();
        let itemOptions = itemResult.options();
        let optionList = itemOptions.list();
        let repairedOptionList = itemResult.repairedItemOptions().list();
        logger.info("          Item Result   Id : {0}   --------------------------", itemResult.id());
        logger.info("          Item          Id : {0}({1})[{2}]", [item.name(), item.id(), item.type()]);
        logger.info("          Item Options Size: {0}", itemOptions.size());
        for (let option of optionList) {
          logger.info("                   Item Option: {0}({1})", [option.name(), option.id()]);
        }
        logger.info("          Repaired Options: {0}", repairedOptionList.length);
        for (let repairedOption of repairedOptionList) {
          logger.info("                   Repaired Option: {0}({1})", [repairedOption.name(), repairedOption.id()]);
        }
        logger.info("          Result Type     : {0}", itemResult.resultType());
        logger.info("          Value           : {0}", itemResult.value());
        logger.info("          Remarks         : {0}", itemResult.remarks());
      }

      logger.info("       End Checklist Item Results --------------------------");
      logger.info("End Checklist Result Id: {0}", checklistResult.id());
    }

    let repairResults = this.repairResults();
    let repairResultList = repairResults.list();
    for (let repairResult of repairResultList) {
      repairResult.debug();
    }
  }

  gpsLocation() {
    return this.getString(Inspection.Fields.GPS_LOCATION);
  }
}